import { Axios } from "axios";
import { setCanvasSlide } from "../../canvasUtils";
import { setIdle } from "../../store/common/appStateSlice";
import { closePopover } from "../../store/common/uiSlice";
import {
  addObject,
  removeObject,
  setCurrentSlideIndex,
  addSlide,
  duplicateSlide,
  removeSlide,
  updateObject,
  updateSlideTransitions,
} from "../../store/slides/slidesSlice";
import { generateOnlyAvatarVideo, generateVideo } from "../../api/templates";
import { generateVideoBody } from "../../constants/apiRequestBody";
import {
  setGenerateLoading,
  setLoaderValue,
  setUploadMessage,
} from "../../store/editor/canvasSlice";
import { getFromLocal } from "../../utils/localStorage";

export const setCanvasCurrentSlide =
  (canvas, index = 0) =>
  async (dispatch, getState) => {
    try {
      const { slides } = getState().slides;
      const currentSlide = slides[index];
      if (!currentSlide) {
        throw Error("Slide not found");
      }
      setCanvasSlide(currentSlide, canvas, dispatch);
      dispatch(setCurrentSlideIndex(index));
    } catch (error) {
      console.error("Error while setting canvas current slide:", error);
      dispatch(setIdle());
    }
  };

export const addCanvasObject = (payload) => async (dispatch, getState) => {
  try {
    dispatch(addObject({ data: payload }));
    dispatch(closePopover());
  } catch (error) {
    console.error("Error while adding object into the canvas slide:", error);
    dispatch(setIdle());
  }
};

export const updateCanvasObject = (payload) => async (dispatch, getState) => {
  try {
    dispatch(updateObject({ data: payload }));
  } catch (error) {
    console.error("Error while adding object into the canvas slide:", error);
    dispatch(setIdle());
  }
};

export const goToSlide = (index, canvas) => async (dispatch, getState) => {
  dispatch(setCurrentSlideIndex(index));
  const { slides } = getState().slides;
  return setCanvasSlide(
    { canvasData: slides[index]?.objects || [] },
    canvas,
    dispatch
  );
};

// update slide info like background, scriptData, transitions etc.
export const updateSlideInfo = (payload) => async (dispatch, getState) => {
  try {
    if (payload.transitionData) {
      dispatch(updateSlideTransitions({ ...payload.transitionData }));
    }
  } catch (error) {
    console.error("Error while updating canvas slide info:", error);
  }
};

export const removeCanvasObject = (payload) => async (dispatch, getState) => {
  try {
    dispatch(removeObject({ data: payload }));
  } catch (error) {
    console.error("Error while removing object:", error);
  }
};

// export const addCanvasSlide = (payload) => (dispatch) => {};
// export const newAbortSignal = () => async () => {
//   let abortController;
//   abortController = new AbortController();
//   return abortController.signal;
// };

export const FianalGenerateVideo = () => async (dispatch, getState) => {
  const slides = getState().slides.slides;
  const project = getState().project;
  const { height, width, layout } = getState().canvas;
  const userId = getFromLocal("userId");

  const reqObj = {
    slides: [...slides],
    layout: `w=${width}xh=${height}` || "w=1920xh=1080",
    dimension: layout,
    bgmusic: project.bgmusic || null,
    dimension: layout,
    cover: {
      is_cover: false,
    },
    free: false,
    userId: userId,
    projectId: project?.id || "wqwupxmd64",
  };
  const response = generateVideoBody(reqObj, project);
  const resp = await generateVideo(response);
  if (resp) {
    dispatch(setUploadMessage("We'll email you when your video is ready!"));
    dispatch(setGenerateLoading(false));
  }
};

export const generateOnlyAvatarVideoFun =
  (params) => async (dispatch, getState) => {
    try {
      const project = getState().project;

      const userId = getFromLocal("userId");
      const params1 = {
        ...params,
        userId: userId,
        projectId: project?.id,
      };
      const response = await generateOnlyAvatarVideo(params1);
      if (response) {
        dispatch(setLoaderValue(100));
      }
    } catch (error) {
      console.log("error", error.response.data.message);
      // showToast(error.response.data.message, "", "danger");
    }
  };

export const addCanvasSlide = (payload) => (dispatch) => {
  try {
    dispatch(addSlide(payload));
  } catch (error) {
    console.error("Error while adding canvas slide:", error);
  }
};
export const removeCanvasSlide = (payload) => (dispatch, getState) => {
  try {
    // const { id } = getState().project;
    dispatch(removeSlide(payload));
    // dispatch(saveProject(id));
  } catch (error) {
    console.error("Error while adding canvas slide:", error);
  }
};
export const duplicateCanvasSlide = (payload) => (dispatch) => {
  try {
    dispatch(duplicateSlide(payload));
  } catch (error) {
    console.error("Error while adding canvas slide:", error);
  }
};
